import { PERK_TYPE_PROMO_CODE } from "constants/perksAdmin";
import { PerkFormValues } from "components/perksCrm/perksCrm.types";
import { AdminPerk } from "store/apis/perksCrm";

export const EMPTY_PERK_FORM_VALUES: PerkFormValues = {
  name: "",
  description: "",
  perk_type: PERK_TYPE_PROMO_CODE,
  website: "",
  contact_email: "",
  heading: "",
  offer_description: "",
  linkedin_url: "",
  promo_code: "",
  promo_code_redeem_url: "",
  special_url: "",
  intro_emails: [],
  special_email: "",
  generic_instruction: "",
  redeem_instruction: "",
  instructions: "",
  bg_color_hex: "",
  icon: null,
};

export const getPerkFormValuesFromPerk = (perk: AdminPerk): PerkFormValues => ({
  name: perk.name || "",
  description: perk.description || "",
  perk_type:
    (perk.perk_type as PerkFormValues["perk_type"]) || PERK_TYPE_PROMO_CODE,
  website: perk.website || "",
  contact_email: perk.contact_email || "",
  heading: perk.heading || "",
  offer_description: perk.offer_description || "",
  linkedin_url: perk.linkedin_url || "",
  promo_code: perk.promo_code || "",
  promo_code_redeem_url: perk.promo_code_redeem_url || "",
  special_url: perk.special_url || "",
  intro_emails: perk.intro_emails || [],
  special_email: perk.special_email || "",
  generic_instruction: perk.generic_instruction || "",
  redeem_instruction: perk.redeem_instruction || "",
  instructions: perk.instructions || "",
  bg_color_hex: perk.icon_bg_color || "",
  icon: null,
});
